<template>
  <div>
    <h1>Crea il tuo ordine</h1>
    <form @submit.prevent="submitOrder">
      <input v-model="order.billing.first_name" type="text" placeholder="Nome" required>
      <input v-model="order.billing.last_name" type="text" placeholder="Cognome" required>
      <input v-model="order.billing.email" type="email" placeholder="Email" required>
      <input v-model="order.billing.phone" type="text" placeholder="Telefono" required>
      <!-- Altri campi di indirizzo -->

      <!-- Selezione del metodo di pagamento -->
      <select v-model="order.payment_method" required>
        <option value="bacs">Bonifico Bancario (BACS)</option>
        <option value="paypal">PayPal</option>
      </select>

      <!-- In base al metodo di pagamento scelto, potresti voler mostrare informazioni aggiuntive -->

      <button type="submit">Invia Ordine</button>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      order: {
        payment_method: 'bacs', // Metodo di pagamento predefinito
        payment_method_title: 'Direct Bank Transfer', // Titolo del metodo di pagamento predefinito
        set_paid: false, // Imposta a false per non marcare l'ordine come pagato
        billing: {
          first_name: '',
          last_name: '',
          email: '',
          phone: '',
          // Aggiungi qui il resto dei campi di indirizzo
        },
        shipping: {
          // I dati di spedizione possono essere uguali a quelli di fatturazione o diversi
        },
        line_items: [
          {
            product_id: 51203, // Sostituisci con l'ID del prodotto scelto
            quantity: 1 // Aggiungi la logica per selezionare la quantità
          }
        ],
        shipping_lines: [
          {
            method_id: 'flat_rate',
            method_title: 'Flat Rate',
            total: '10.00' // Sostituisci con il costo effettivo di spedizione
          }
        ]
      }
    };
  },
  watch: {
    'order.payment_method': function(newMethod) {
      // Aggiorna il titolo del metodo di pagamento in base alla selezione
      this.order.payment_method_title = newMethod === 'bacs' ? 'Direct Bank Transfer' : 'PayPal';
    }
  },
  methods: {
    submitOrder() {
      fetch('https://us-central1-fusco-fit-connect-4b731.cloudfunctions.net/createOrder', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(this.order),
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        if (data.paymentUrl) {
          // Reindirizza l'utente all'URL di pagamento
          window.location.href = data.paymentUrl;
        } else {
          // Gestisci la creazione dell'ordine senza URL di pagamento
          this.$emit('order-created', data.order);
        }
      })
      .catch(error => {
        console.error('Errore:', error);
        this.$emit('order-error', error);
      });
    }
  }
};
</script>

